import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class RolePermissionModel extends Model implements IModel<RolePermissionModel> {
    moduleActionId: string = '';
    roleId: string = '';

    static create(input: any): RolePermissionModel {
        return ObjectMapper.deserialize<RolePermissionModel>(RolePermissionModel, input);
    }

    public toJSON(): string {
        return ObjectMapper.serialize(this) as string;
    }
}
